import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Lightbulb = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path d="M13 4V2H11V4H13Z" fill="currentColor" />
    <path d="M4 13H2V11H4V13Z" fill="currentColor" />
    <path d="M22 13H20V11H22V13Z" fill="currentColor" />
    <path d="M5.70711 4.29289L7.20711 5.79289L5.79289 7.20711L4.29289 5.70711L5.70711 4.29289Z" fill="currentColor" />
    <path d="M18.2071 7.20711L19.7071 5.70711L18.2929 4.29289L16.7929 5.79289L18.2071 7.20711Z" fill="currentColor" />
    <path d="M14.5 20V22H9.5V20H14.5Z" fill="currentColor" />
    <path
      d="M7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 13.7473 15.5044 15.2638 14.0448 16.0099L13.5 16.2884V18.5H15.5V17.478C17.3026 16.324 18.5 14.3025 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 14.3025 6.69741 16.324 8.5 17.478V18.5H10.5V16.2884L9.95517 16.0099C8.49564 15.2638 7.5 13.7473 7.5 12Z"
      fill="currentColor"
    />
  </Icon>
));

export default Lightbulb;
